export const backendApiURL = "https://func-devsecopshub-prod.azurewebsites.net/api/"
export const _tenantName = "oktaProd"
export const _clientID = "0oa9sx5me1zLy7omN417"
export const replyURL = window.location.origin
export const sentryDsn = "https://dc93eeb1892f55a1d93eb9f346278945@o4507922417975296.ingest.de.sentry.io/4508778509238352"
export let releaseId = "Hub Prod 1957295"

export const clientID = (function() {
    if(window.location.hostname === "localhost"){
        return "0oa9pl462iCWijSZT417"
    } else {
        return _clientID
    }
}())

export const tenantName = (function() {
    if(window.location.hostname === "localhost"){
        return "dev."
    } else {
        // @ts-ignore
        if(_tenantName === "oktaDev") {
            return "dev."
        } else {
            return ""
        }
    }
}())

export let getReleaseIdSentry = (function() {
    if (releaseId.indexOf("RELEASEID") !== -1 || releaseId.length === 0) {
        return "DevSecOps Hub Dev"
    }
    return releaseId
}())

export const ENVIRONMENT = (function() {
    if(window.location.hostname === "localhost" || window.location.origin.includes("stdevsecopshubstage")) {
        return "dev"
    } else {
        return "prod"
    }
}())
